export default __webpack_public_path__ + "static/media/trade-code-editor.86d97dea.mp4";